// File: src/components/tables/GenericTable/TableFilters.tsx
import React from "react";
import styled from "styled-components";
import { Flex } from "../../layouts";
import { Typography } from "../../general/Typography";

export interface TableFiltersProps {
  searchPlaceholder?: string;
  searchQuery?: string;
  onSearchChange?: (value: string) => void;
  children?: React.ReactNode; // for extra filters like role/group/etc.
}

const FilterWrapper = styled(Flex)`
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SearchInput = styled.input`
  padding: ${({ theme }) => theme.spacing.sm};
  font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
  border-radius: ${({ theme }) => theme.radii.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};
  width: 100%;
  max-width: 280px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary+'33'};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 100%;
  }
`;

const FilterGroup = styled(Flex)`
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
    flex-direction: column;
  }
`;

export const TableFilters: React.FC<TableFiltersProps> = ({
  searchPlaceholder = "Search...",
  searchQuery = "",
  onSearchChange,
  children,
}) => {
  return (
    <FilterWrapper>
      <SearchInput
        type="text"
        placeholder={searchPlaceholder}
        value={searchQuery}
        onChange={(e) => onSearchChange?.(e.target.value)}
      />

      {children && <FilterGroup>{children}</FilterGroup>}
    </FilterWrapper>
  );
};